import { Button, Form, Input } from "antd";
import LayoutLogin from "../layoutLogin";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { _adr, _ckey } from "../../../address";
import { ModalSuspend } from "../modal";
import { useEffect, useState } from "react";
import { useAPIPublic } from "../../../tools/api";
import { app_Cookie_Remove } from "../../../tools/services";
import { convertPersian, validateInput } from "../../../tools/tools";

const ForgetPassword = () => {
  const [t] = useTranslation("global");
  const { sendOTPCodeAsync } = useAPIPublic();
  const [isProgress, setIsProgress] = useState(false);
  const nav = useNavigate();
  const handleSubmit = async (param) => {
    app_Cookie_Remove(_ckey.expiretimeLogin);
    setIsProgress(true);
    let payload = {
      sessionid: Date.now(),
      msisdn: "09" + param.username,
      expiretimebyminute: process.env.REACT_APP_LOGIN_EXPIRE,
    };
    let response = await sendOTPCodeAsync(payload);
    if (response) {
      nav(_adr.Root + _adr.Login.OtpConfirm, {
        state: {
          sessionid: response.sessionid,
          expiretime: parseInt(response.expiretime.split(":")[1]) * 60,
          loginState: false,
          msisdn: response.otpnumber,
        },
      });
    }
    setIsProgress(false);
  };
  return (
    <>
      <LayoutLogin>
        <div className="holder-title-form">
          <h3>{t("form.forgetPasswordText")}</h3>
        </div>
        <Form
          name="normal_login"
          className="login-form"
          onFinish={handleSubmit}
        >
          <Form.Item
            name="username"
            className="input-normal"
            rules={[
              validateInput({
                t: t,
                type: "msisdn",
              }),
            ]}
          >
            <div>
              <Input
                dir="ltr"
                prefix={<i className="icon-user"></i>}
                suffix={<span>09</span>}
                maxLength={9}
                placeholder={t("form.msisdn")}
                autoComplete="off"
                inputMode="numeric"
                onChange={(e) => {
                  e.target.value = convertPersian(e.target.value);
                }}
              />

              <Link to={_adr.Root + _adr.Login.Index}>
                {t("form.loginWhitUserAndPass")}
              </Link>
            </div>
          </Form.Item>

          <Form.Item>
            <Button
              type="default"
              htmlType="submit"
              className={`btn-normal btn-aptel ${isProgress && "disabled"}`}
              disabled={isProgress}
              danger
            >
              {isProgress ? t("form.inProgress") : t("form.send")}
            </Button>
          </Form.Item>
        </Form>
        <ModalSuspend action="false" />
      </LayoutLogin>
    </>
  );
};

export default ForgetPassword;
